import { Tournament, TournamentStatus } from "model/Tournament/Tournament";
import {
  selectTourShortTitleDisplayForTournamentId,
  selectTourTitleDisplayForTournamentId,
} from "selectors/Tour";
import { Option } from "./Option";
import { useAppSelector } from "app/hooks";

interface Props {
  tournament: Tournament;
  status: TournamentStatus;
}

export const TournamentOption = ({ tournament, status }: Props) => {
  const tourTitle = useAppSelector((state) =>
    selectTourTitleDisplayForTournamentId(state, tournament.id)
  );

  const tourShortTitle = useAppSelector((state) =>
    selectTourShortTitleDisplayForTournamentId(state, tournament.id)
  );

  const tournamentDetailsShort = `${tournament.trigram} ${
    !!tourShortTitle ? ` - ${tourShortTitle}` : ""
  }`;

  const tournamentDetailsLong = `${tournament.name} ${
    !!tourTitle ? ` - ${tourTitle}` : ""
  }`;

  return (
    <Option
      type="Tournament"
      id={tournament.id}
      status={status}
      endTime={tournament.endTimeMs}
      startTime={tournament.startTimeMs}
      name={tournamentDetailsShort}
      title={tournamentDetailsLong}
    />
  );
};
